import React, { useMemo } from "react"
import { gql, useQuery } from "@apollo/client"
import PPLoadingIndicator from "../layout/PPLoadingIndicator"
import PPErrorDisplay from "../layout/PPErrorDisplay"
import { useTranslation } from "react-i18next"
import DataTable from "react-data-table-component"
import countries from "i18n-iso-countries"
import PPExpandedRowStatTableCountPriceLower from "./PPExpandedRowStatTableCountPriceLower"
import "../../styles/pricetable.css"

const QUERY = gql`
    query getStats($department: String) {
        stats(department: $department) {
            statTableCountPriceLower {
                shopId
                name
                shortName
                lang

                countAllPrice
                countPriceLower
                procentPriceLower
                procentAverageDiscount

                mostPriceChangeHotProducts {
                    customerId
                    id
                    lastPriceChangesOverAllShops {
                        price
                        shopName
                        lang
                        crawlDate
                    }
                    priceChangesLast5Days
                    priceTrendToCustomerPrice
                    productImage
                    productName
                    productnr
                    productProducer
                    price
                    minPrice
                }
            }
        }
    }
`

const CustomRowShopname = ({ row }) => {
    const [i18n] = useTranslation()

    return (
        <div className="mt-2 mb-2">
            <div>
                <span title={countries.getName(row.lang, i18n.language)} className={"fi fi-" + row.lang} /> {row.name}
            </div>
        </div>
    )
}

function PPStatTableCountPriceLower(props) {
    const [t] = useTranslation()
    const variables = useMemo(
        () => ({
            department:
                props?.changeFilterDepartment != null && props?.changeFilterDepartment?.name != ""
                    ? props?.changeFilterDepartment?.name
                    : ""
        }),
        [props?.changeFilterDepartment]
    )

    const { loading, error, data } = useQuery(QUERY, {
        displayName: "PPStatTableCountPriceLower",
        variables,
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first"
    })

    const columns = useMemo(() => [
        {
            name: t("dashboard.stattablecountpricelower_products.col_1"),
            selector: (row) => row.name,
            cell: (row) => <CustomRowShopname row={row} />
        },
        {
            name: t("dashboard.stattablecountpricelower_products.col_2"),
            selector: (row) => row.countAllPrice,
            sortable: true
        },
        {
            name: t("dashboard.stattablecountpricelower_products.col_3"),
            selector: (row) => row.countPriceLower,
            sortable: true
        },
        {
            name: t("dashboard.stattablecountpricelower_products.col_4"),
            selector: (row) => row.procentPriceLower,
            sortable: true,
            cell: (row) => row?.procentPriceLower?.toFixed(2)
        },
        {
            name: t("dashboard.stattablecountpricelower_products.col_5"),
            selector: (row) => row.procentAverageDiscount,
            sortable: true,
            cell: (row) => row?.procentAverageDiscount?.toFixed(2)
        }
    ])

    if (loading && !data) return <PPLoadingIndicator />
    if (error)
        return (
            <div className="col-lg-12">
                <PPErrorDisplay error={error} />
            </div>
        )

    return (
        <div className="col-lg-12">
            <div className="card shadow d-flex flex-fill">
                <div className="card-header">
                    <h3 className="card-title">{t("dashboard.stattablecountpricelower_products.header")}</h3>
                </div>
                <div className="card-body datatable_headerbold">
                    {data?.stats?.statTableCountPriceLower?.length > 0 ? (
                        <DataTable
                            noHeader
                            columns={columns}
                            data={data?.stats?.statTableCountPriceLower}
                            pagination
                            paginationRowsPerPageOptions={[10, 20, 30]}
                            defaultSortField="procentAverageDiscount"
                            expandOnRowClicked
                            expandableRows
                            expandableRowsComponent={PPExpandedRowStatTableCountPriceLower}
                            expandableRowsComponentProps={{ tariffComparisonMode: props?.tariffComparisonMode }}
                        />
                    ) : (
                        t("single.no_results")
                    )}
                </div>
            </div>
        </div>
    )
}

export default PPStatTableCountPriceLower
